<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  name: 'minimal-layout'
}
</script>



// WEBPACK FOOTER //
// MinimalLayout.vue?3cce4fa8